import TestimonialCard from "@/components/marketing/TestimonialCard";
import type { Laid } from "@/content/landing/sectionLayout";
import { LandingSection } from "../LandingPrimitives";
import { sectionPad } from "./landingRun";

/**
 * `.dash-test_wrap` on a landing page: the review card the feature pages draw,
 * in `.container_new.padding-bottom`'s short close and with no entrance fade,
 * which the campaign pages publish without.
 */
export default function TestimonialBlock({
  block,
}: {
  block: Laid<"testimonial">;
}) {
  return (
    <LandingSection padding={block.pad ? sectionPad(block.pad) : "break"}>
      <TestimonialCard
        title={block.title}
        body={block.body}
        emphasis={block.emphasis}
        initials={block.initials}
        href={block.href}
        newTab={block.newTab}
      />
    </LandingSection>
  );
}
